import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible')
        revealObserver.unobserve(entry.target)
      }
    })
  },
  { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
)

document.querySelectorAll('[data-reveal]').forEach((el) => revealObserver.observe(el))
